module.exports = __webpack_public_path__ + "static/img/vio_ban_en.34204bbf.png";